(function($) {
	'use strict';


	var Sortable, sortableContainerList = [];


	/**
	 * Sortable object
	 * @param {string} name
	 */
	Sortable = function (name) {
		this.name = name;
		this.item;
		this.container;
		this.control;
		this.scrollable;
		this.mobileNode = $('<kd-sortable-container><kd-toolbar>'
			+ '<kd-control class="sort-up"></kd-control>'
			+ '<kd-control class="sort-close"></kd-control>'
			+ '<kd-control class="sort-down"></kd-control>'
			+ '</kd-toolbar></kd-sortable-container>');
		this.xhr = undefined;
	};


	/**
	 * @public
	 * @param   {element} item
	 * @param   {element} control
	 * @param   {element} scrollable
	 * @param   {integer} x
	 * @param   {integer} y
	 * @returns {undefined}
	 */
	Sortable.prototype.activate = function(item, control, scrollable, x, y) {
		this.item = item;
		this.container = item.parent();
		this.control = control;
		this.scrollable = scrollable;

		if ('draggable' in document.createElement('span')) {
			this._initDragAndDrop();
		}
		else if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
			this._initMobile(x,y);
		}
		else {
			alert('Item sorting is not available!');
		}
	};


	/**
	 * @private
	 * @param   {integer} x
	 * @param   {integer} y
	 * @returns {undefined}
	 */
	Sortable.prototype._initMobile = function(x, y) {
		this.control.addClass('active');
		this.item.addClass('movable');

		this.scrollable.addClass('sorted');
		this.mobileNode.on('selectstart',function() {return false;});
		this.mobileNode.css('transform-origin', x + 'px ' + y + 'px');
		$('body').append(this.mobileNode);

		this._initMobileControls();
	};


	/**
	 * @private
	 * @returns {undefined}
	 */
	Sortable.prototype._initDragAndDrop = function() {
		var sortable = this, itemIndex;

		sortable.item.attr('draggable',true);
		itemIndex = sortable._getItemIndex();

		$.each(sortable.container.children(), function (index, child) {
			var item = $(child);

			if (itemIndex === index) {
				return;
			}

			item.addClass('dropable');
			item.on('drop', function (event) {
				var target;

				target = $(event.currentTarget);
				target.removeClass('hover');
				target.removeClass('dropable');

				if (index > itemIndex && sortable.container.data('action-sortable') !== undefined) {
					sortable.item.insertAfter(target);
					sortable._save();
				}

				if (index < itemIndex && sortable.container.data('action-sortable') !== undefined) {
					sortable.item.insertBefore(target);
					sortable._save();
				}

				event.preventDefault();
			});

			item.on('dragover', function (event) {
				event.preventDefault();
				return false;
			});

			item.on('dragenter', function (event) {
				$(this).addClass('hover');
			});

			item.on('dragleave', function (event) {
				$(this).removeClass('hover');
			});
		});

		sortable.item.on('dragstart', function(event) {
			setTimeout(function() {
				sortable.control.addClass('active');
				sortable.item.addClass('movable');
			},50);
		});

		sortable.item.on('dragend', function(event) {
			sortable.control.removeClass('active');
			sortable.item.removeClass('movable');
			sortable.item.removeAttr('draggable');

			$.each(sortable.container.children(), function (index, child) {
				var item = $(child);

				item.off('drop');
				item.off('dragover');
				item.off('dragenter');
				item.off('dragleave');

				item.removeClass('hover');
				item.removeClass('dropable');
			});

			sortable.item.off('dragstart');
			sortable.item.off('dragend');
		});
	};


	/**
	 * @private
	 * @returns {undefined}
	 */
	Sortable.prototype._initMobileControls = function() {
		var sortable = this, itemIndex;

		itemIndex = sortable._getItemIndex();

		sortable._initMobileSortControls();

		sortable.mobileNode.find('kd-control.sort-close').click(function (event) {
			if (typeof navigator === 'object' && typeof navigator.vibrate === 'function') {
				navigator.vibrate(35);
			}

			sortable.scrollable.removeClass('sorted');
			sortable.mobileNode.remove();
			sortable.control.removeClass('active');
			sortable.item.removeClass('movable');

			if (sortable._getItemIndex() !== itemIndex && sortable.container.data('action-sortable') !== undefined) {
				sortable._save();
			}

			event.preventDefault();
		});

		sortable.mobileNode.find('kd-control.sort-up').click(function (event) {
			var previous, top;

			if (typeof navigator === 'object' && typeof navigator.vibrate === 'function') {
				navigator.vibrate(35);
			}

			previous = sortable.item.prev();

			if (previous !== undefined) {
				sortable.item.insertBefore(previous);
				top = sortable.item.offset().top - (window.innerHeight / 2) + (sortable.item.outerHeight() / 2);
				sortable.scrollable.scrollTop(top);

				sortable._initMobileSortControls();
			}

			event.preventDefault();
			return false;
		});

		sortable.mobileNode.find('kd-control.sort-down').click(function (event) {
			var next, top;

			if (typeof navigator === 'object' && typeof navigator.vibrate === 'function') {
				navigator.vibrate(35);
			}

			next = sortable.item.next();

			if (next !== undefined) {
				sortable.item.insertAfter(next);
				top = sortable.item.offset().top - (window.innerHeight / 2) + (sortable.item.outerHeight() / 2);
				sortable.scrollable.scrollTop(top);

				sortable._initMobileSortControls();
			}

			event.preventDefault();
			return false;
		});
	};


	/**
	 * @private
	 * @returns {undefined}
	 */
	Sortable.prototype._initMobileSortControls = function() {
		if (this.item.is(':first-child')) {
			this.mobileNode.find('kd-control.sort-up').addClass('disabled');
		}
		else {
			this.mobileNode.find('kd-control.sort-up').removeClass('disabled');
		}

		if (this.item.is(':last-child')) {
			this.mobileNode.find('kd-control.sort-down').addClass('disabled');
		}
		else {
			this.mobileNode.find('kd-control.sort-down').removeClass('disabled');
		}
	};


	/**
	 * @private
	 * @returns {undefined}
	 */
	Sortable.prototype._save = function() {
		var sortable = this, list = [];

		if (sortable.xhr && sortable.xhr.readyState !== 4) {
			sortable.xhr.abort();
		}

		this.container.children().each(function() {
			list.push($(this).data('id'));
		});

		sortable.xhr = $.post(sortable.container.data('action-sortable'), {list: list});
	};


	/**
	 * @private
	 * @returns {undefined|integer}
	 */
	Sortable.prototype._getItemIndex = function() {
		var sortable = this, itemIndex;

		$.each(sortable.container.children(), function (index, value) {
			if (sortable.item.data('id') === $(value).data('id')) {
				itemIndex = index;

				return;
			}
		});

		return itemIndex;
	};


	/**
	 * @public
	 * @param   {function} callback
	 * @returns {this}
	 */
	$.fn.sortable = function(callback) {
		if ('draggable' in document.createElement('span')) {
			this.mousedown(callback);
		}
		else if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
			this.click(callback);
		}
		else {
			alert('Item sorting is not available!');
		}

		return this;
	};


	/**
	 * @public
	 * @param   {string} name
	 * @returns {Sortable}
	 */
	$.sortable = function(name) {
		if (sortableContainerList[name] === undefined) {
			sortableContainerList[name] = new Sortable(name);
		}

		return sortableContainerList[name];
	};

}(jQuery));
